export default {
  cookie_consent_statistics_description:
    'Statistical cookies help us understand how visitors use our website by collecting and reporting data as anonymously as possible.',
  cookie_consent_marketing_description:
    'Marketing cookies are used to track visitors across websites. The intention is to display ads that are relevant and engaging for the individual user.',
  cookie_consent_more_info: 'More information about our cookies can be found in our Cookie Policy',
  cookie_consent_more_link: '',
};
